export const widgetStyles = `
:host {
  all: initial;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  --orca-primary: #0039a7;
  --orca-primary-dark: #002d85;
  --orca-primary-accent: #0052cc;
  --orca-primary-muted: #b3c9e8;
  --orca-surface: #fff;
  --orca-surface-muted: #f8fafc;
  --orca-surface-elevated: #fff;
  --orca-border: #e2e8f0;
  --orca-text: #0f172a;
  --orca-text-muted: #334155;
  --orca-input-bg: #fff;
  --orca-input-border: #cbd5e1;
  --orca-input-text: #0f172a;
  --orca-shadow: rgba(15, 23, 42, 0.18);
  --orca-shadow-strong: rgba(15, 23, 42, 0.12);
  --orca-primary-surface: #e8f0fa;
  --orca-channel-hover: #d6e4f5;
  --orca-cancel-bg: #e2e8f0;
  --orca-cancel-text: #334155;
  --orca-error-bg: #fef2f2;
  --orca-error-text: #b91c1c;
  --orca-error-border: #fecaca;
  --orca-focus-ring: rgba(0, 57, 167, 0.25);
}

:host([data-theme="dark"]) {
  --orca-primary-muted: #1e4a8a;
  --orca-surface: #111827;
  --orca-surface-muted: #0b1220;
  --orca-surface-elevated: #1e293b;
  --orca-border: #334155;
  --orca-text: #f1f5f9;
  --orca-text-muted: #94a3b8;
  --orca-input-bg: #1e293b;
  --orca-input-border: #475569;
  --orca-input-text: #f8fafc;
  --orca-shadow: rgba(0, 0, 0, 0.45);
  --orca-shadow-strong: rgba(0, 0, 0, 0.35);
  --orca-primary-surface: rgba(0, 57, 167, 0.24);
  --orca-channel-hover: rgba(0, 57, 167, 0.38);
  --orca-cancel-bg: #334155;
  --orca-cancel-text: #e2e8f0;
  --orca-error-bg: #3f1d1d;
  --orca-error-text: #fca5a5;
  --orca-error-border: #7f1d1d;
  --orca-focus-ring: rgba(96, 165, 250, 0.35);
}

* {
  box-sizing: border-box;
}

.panel {
  position: fixed;
  width: 380px;
  max-width: calc(100vw - 32px);
  height: 520px;
  max-height: calc(100vh - 96px);
  background: var(--orca-surface);
  color: var(--orca-text);
  border-radius: 16px;
  box-shadow: 0 12px 40px var(--orca-shadow);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--orca-border);
  transition: width 0.2s ease, height 0.2s ease, border-radius 0.2s ease,
    background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.panel.maximized {
  width: var(--orca-expanded-width, 30vw);
  max-width: var(--orca-expanded-width, 30vw);
  height: 100vh;
  max-height: 100vh;
  border-radius: 0;
  box-shadow: -8px 0 32px var(--orca-shadow-strong);
}

.panel.hidden {
  display: none;
}

.panel.bottom-right {
  right: 24px;
  bottom: 88px;
}

.panel.bottom-left {
  left: 24px;
  bottom: 88px;
}

.panel.maximized.bottom-right {
  right: 0;
  bottom: 0;
}

.panel.maximized.bottom-left {
  left: 0;
  bottom: 0;
}

.panel.fullscreen {
  width: 100vw !important;
  max-width: 100vw !important;
  height: 100vh !important;
  max-height: 100vh !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

:host([data-fullscreen="true"][data-panel-open="true"]) .launcher {
  display: none;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: linear-gradient(135deg, var(--orca-primary), var(--orca-primary-accent));
  color: #fff;
}

.header-logo {
  width: 30%;
  max-width: 72px;
  min-width: 40px;
  height: auto;
  aspect-ratio: 1;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35);
}

.header-text {
  min-width: 0;
  flex: 1;
}

.header h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.header p {
  margin: 4px 0 0;
  font-size: 12px;
  opacity: 0.9;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.palette-picker {
  position: relative;
}

.palette-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 124px;
  height: 32px;
  padding: 0 8px 0 6px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.palette-trigger:hover {
  background: rgba(255, 255, 255, 0.28);
}

.palette-trigger:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.palette-trigger-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.palette-caret {
  font-size: 10px;
  opacity: 0.85;
}

.palette-swatch {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.55);
  flex-shrink: 0;
  background: #0039a7;
}

.palette-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 5;
  min-width: 168px;
  max-height: 260px;
  overflow-y: auto;
  padding: 6px;
  border-radius: 12px;
  background: var(--orca-surface-elevated);
  color: var(--orca-text);
  border: 1px solid var(--orca-border);
  box-shadow: 0 12px 28px var(--orca-shadow);
}

.palette-menu[hidden] {
  display: none;
}

.palette-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}

.palette-option .palette-swatch {
  border-color: rgba(15, 23, 42, 0.18);
}

:host([data-theme="dark"]) .palette-option .palette-swatch {
  border-color: rgba(255, 255, 255, 0.28);
}

.palette-option:hover,
.palette-option:focus-visible {
  background: var(--orca-primary-surface);
  outline: none;
}

.palette-option.is-selected {
  background: var(--orca-primary-surface);
  font-weight: 600;
}

.icon-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-btn:hover {
  background: rgba(255, 255, 255, 0.28);
}

.icon-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: var(--orca-surface-muted);
}

.message {
  max-width: 88%;
  padding: 10px 12px;
  border-radius: 12px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.message.rich {
  white-space: normal;
}

.message.rich p {
  margin: 0 0 8px;
}

.message.rich p:last-child {
  margin-bottom: 0;
}

.message.rich strong {
  font-weight: 700;
}

.message.rich em {
  font-style: italic;
}

.message.rich code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.92em;
  padding: 1px 5px;
  border-radius: 4px;
  background: var(--orca-primary-surface);
  color: var(--orca-primary);
}

.message.rich a {
  color: var(--orca-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.message.user {
  margin-left: auto;
  background: var(--orca-primary);
  color: #fff;
  border-bottom-right-radius: 4px;
}

.message.assistant {
  background: var(--orca-surface-elevated);
  color: var(--orca-text);
  border: 1px solid var(--orca-border);
  border-bottom-left-radius: 4px;
}

.message.system {
  background: var(--orca-primary-surface);
  color: var(--orca-primary);
  font-size: 12px;
}

:host([data-theme="dark"]) .message.system {
  color: #93c5fd;
}

.message.error {
  background: var(--orca-error-bg);
  color: var(--orca-error-text);
  border: 1px solid var(--orca-error-border);
}

.message.processing {
  max-width: 100%;
  background: var(--orca-primary-surface);
  color: var(--orca-primary);
  border: 1px dashed var(--orca-primary-muted);
  font-size: 13px;
  font-style: italic;
  animation: tai-processing-pulse 1.6s ease-in-out infinite;
}

:host([data-theme="dark"]) .message.processing {
  color: #93c5fd;
}

@keyframes tai-processing-pulse {
  0%,
  100% {
    opacity: 0.72;
  }
  50% {
    opacity: 1;
  }
}

.confirm-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.confirm-actions button {
  flex: 1;
  border: none;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  cursor: pointer;
}

.confirm-actions .confirm {
  background: var(--orca-primary);
  color: #fff;
}

.confirm-actions .confirm:hover {
  background: var(--orca-primary-dark);
}

.confirm-actions .cancel {
  background: var(--orca-cancel-bg);
  color: var(--orca-cancel-text);
}

.confirm-actions.domain-confirm {
  flex-direction: column;
  align-items: stretch;
}

.confirm-actions.domain-confirm .confirm-copy {
  font-size: 13px;
  color: var(--orca-text-muted);
}

.confirm-actions.domain-confirm .confirm-buttons {
  display: flex;
  gap: 8px;
}

.input-row {
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--orca-border);
  background: var(--orca-surface);
}

.input-row input {
  flex: 1;
  border: 1px solid var(--orca-input-border);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  background: var(--orca-input-bg);
  color: var(--orca-input-text);
}

.input-row input::placeholder {
  color: var(--orca-text-muted);
}

.input-row input:focus {
  outline: 2px solid var(--orca-focus-ring);
  border-color: var(--orca-primary);
}

.input-row button {
  border: none;
  border-radius: 10px;
  padding: 0 14px;
  background: var(--orca-primary);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

.input-row button:hover:not(:disabled) {
  background: var(--orca-primary-dark);
}

.input-row button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.launcher {
  position: fixed;
  width: 64px;
  height: 64px;
  padding: 0;
  border-radius: 999px;
  border: none;
  background: #050a18;
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(0, 40, 120, 0.45);
}

.launcher-logo {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
}

.launcher:hover {
  transform: translateY(-1px) scale(1.03);
  box-shadow: 0 12px 32px rgba(0, 180, 220, 0.35);
}

.launcher:focus-visible {
  outline: 2px solid #22d3ee;
  outline-offset: 3px;
}

.launcher.bottom-right {
  right: 24px;
  bottom: 24px;
}

.launcher.bottom-left {
  left: 24px;
  bottom: 24px;
}

.channel-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.channel-actions button {
  border: 1px solid var(--orca-primary-muted);
  border-radius: 10px;
  padding: 10px 12px;
  background: var(--orca-primary-surface);
  color: var(--orca-primary);
  font-weight: 600;
  cursor: pointer;
  text-align: left;
}

:host([data-theme="dark"]) .channel-actions button {
  color: #bfdbfe;
}

.channel-actions button:hover {
  background: var(--orca-channel-hover);
}

.channel-actions button.channel-cancel {
  border: 1px solid var(--orca-border);
  background: var(--orca-cancel-bg);
  color: var(--orca-cancel-text);
  text-align: center;
}

.channel-actions button.channel-cancel:hover {
  filter: brightness(0.97);
}

.domain-offer-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.domain-offer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid var(--orca-primary-muted);
  border-radius: 10px;
  padding: 10px 12px;
  background: var(--orca-primary-surface);
}

.domain-offer-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.domain-offer-label strong {
  color: var(--orca-text);
  font-size: 13px;
  word-break: break-all;
}

.domain-offer-label span {
  color: var(--orca-text-muted);
  font-size: 12px;
}

.domain-add-cart {
  flex-shrink: 0;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  background: var(--orca-primary);
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.domain-add-cart:hover {
  filter: brightness(1.05);
}

.domain-offer-dismiss {
  display: flex;
  justify-content: center;
}

.domain-offer-dismiss .link-cancel {
  border: none;
  background: transparent;
  color: var(--orca-text-muted);
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  padding: 4px;
}

.domain-offer-dismiss .link-cancel:hover {
  color: var(--orca-text);
}

.message table.domain-table {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
  font-size: 12px;
}

.message table.domain-table td {
  border: 1px solid var(--orca-border);
  padding: 6px 8px;
}
`;
